// Library Imports
import React, { useCallback, useContext } from 'react'
import { Link } from 'react-router-dom'
import * as BiIcons from 'react-icons/bi'
import * as RiIcons from 'react-icons/ri'

// Component Imports
import LocationDropDown from '../../components/search/LocationDropDown'
import CategoryDropDown from '../../components/search/CategoryDropDown'

// Asset Imports
import '../../assets/css/stylesheets/ListingSearch.css'
import NameSearch from '../../components/search/NameSearch'
import { DirectoryContext } from '../../contexts/DirectoryContext'

function ListingSearch() {
  const {
    inputSearchText,
    setInputSearchText,
    inputLocation,
    setInputLocation,
    inputCategory,
    setInputCategory,
    inputSubCategory,
    setInputSubCategory,
    subCategoryOptions
  } = useContext(DirectoryContext)

  const handleSearchTextChanged = useCallback((e) => {
    setInputSearchText(e.target.value)
  })

  const handleLocationChanged = useCallback((e) => {
    setInputLocation(e.target.value)
  })

  const handleSubCategoryChanged = useCallback((e) => {
    setInputCategory(subCategoryOptions.filter(s => s.ID == e.target.value)[0].CategoryID);
    setInputSubCategory(e.target.value);
  })

  return (
    <>
      <div className='listingsearch'>
        <div className='listingsearch-text'>
          <NameSearch textValue={inputSearchText} onTextChanged={handleSearchTextChanged} />
          <div className='listingsearch-divider'></div>
        </div>
        <div className='listingsearch-location'>
          <LocationDropDown selectedValue={inputLocation} onLocationChanged={handleLocationChanged} />
          <div className='listingsearch-divider'></div>
        </div>
        <div className='listingsearch-category' >
          <CategoryDropDown selectedValue={inputSubCategory} onCategoryChanged={handleSubCategoryChanged} />
        </div>
        <div className='listingsearch-submit'>
          <Link className='listingsearch-submit-link' to="/listings">
            <BiIcons.BiSearchAlt className='listingsearch-submit-link-icon' />
            Search
          </Link>
        </div>
      </div>
    </>
  )
}

export default ListingSearch